import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { ArrowForward, Store } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { keyframes } from '@emotion/react';

// Animation pour l'arrière-plan
const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
`;

const pulseAnimation = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
`;

const CTA = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        py: { xs: 8, md: 12 },
        overflow: 'hidden',
        background: 'linear-gradient(135deg,rgb(188, 198, 238) 0%, #F04742 25%, #EC4788 50%, #EC4788 75%, #EC4788 100%)',
        // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 25%, #f093fb 50%, #4facfe 75%, #00f2fe 100%)',
        backgroundSize: '400% 400%',
        animation: `${gradientAnimation} 15s ease infinite`,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)',
          pointerEvents: 'none'
        }
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            textAlign: 'center',
            color: 'white'
          }}
        >
          {/* Éléments décoratifs animés */}
          <Box
            sx={{
              position: 'absolute',
              top: '10%',
              left: '10%',
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              animation: `${floatAnimation} 6s ease-in-out infinite`,
              zIndex: 0
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              top: '60%',
              right: '15%',
              width: 150,
              height: 150,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.08)',
              animation: `${floatAnimation} 8s ease-in-out infinite`,
              animationDelay: '1s',
              zIndex: 0
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: '20%',
              left: '20%',
              width: 80,
              height: 80,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.1)',
              animation: `${floatAnimation} 7s ease-in-out infinite`,
              animationDelay: '2s',
              zIndex: 0
            }}
          />

          {/* Contenu principal */}
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
                // textShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                background: 'linear-gradient(45deg, #fff 30%, #f0f0f0 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Prêt à vendre vos produits ?
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mb: 4,
                fontWeight: 400,
                fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem' },
                opacity: 0.95,
                maxWidth: '700px',
                mx: 'auto',
                textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
              }}
            >
 
              Publiez les en quelques clics et atteignez des milliers de clients.
            </Typography>

            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              onClick={() => navigate('/login')}
              sx={{
                px: 5,
                py: 1.5,
                fontSize: { xs: '1rem', md: '1.2rem' },
                fontWeight: 700,
                background: 'linear-gradient(45deg, #ff6b6b 30%, #ee5a6f 90%)',
                color: 'white',
                // boxShadow: '0 8px 24px rgba(238, 90, 111, 0.4)',
                borderRadius: 3,
                textTransform: 'none',
                transition: 'all 0.3s ease',
                // animation: `${pulseAnimation} 3s ease-in-out infinite`,
                '&:hover': {
                  background: 'linear-gradient(45deg, #ee5a6f 30%, #ff6b6b 90%)',
                  boxShadow: '0 12px 32px rgba(238, 90, 111, 0.6)',
                  transform: 'translateY(-2px)',
                  animation: 'none'
                },
                '&:active': {
                  transform: 'translateY(0px)'
                }
              }}
            >
              Publier maintenant
            </Button>

            <Typography
              variant="body2"
              sx={{
                mt: 4,
                opacity: 0.9,
                fontSize: { xs: '0.85rem', md: '1rem' }
              }}
            >
              ✓ Inscription gratuite • ✓ Mise en ligne rapide
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CTA;

